import { Link } from "@tanstack/react-router";
import { Arrow } from "../components/Brand";
import { PageMeta } from "../components/PageMeta";
import { ProjectMedia } from "../components/ProjectMedia";
import { CTASection, PageHero, TagList } from "../components/Sections";
import { clientProjects } from "../data/site";
import { useI18n, useLocalizedContent } from "../i18n";

export function WorkPage() {
  const { l } = useI18n();
  const projects = useLocalizedContent(clientProjects);
  return (
    <>
      <PageMeta title={l("客户案例", "Work")} />
      <PageHero
        eyebrow={l("客户案例", "DELIVERED WORK")}
        title={l(
          "用真实工程，验证产品价值。",
          "Product value, proven through real engineering.",
        )}
        lead={l(
          "从 AI 软件与 SaaS 到 IoT 智能硬件，这里展示 AccSci 已交付并上线的真实客户项目。",
          "From AI software and SaaS to IoT hardware, these are real client products delivered and launched by AccSci.",
        )}
      />
      <section className="work-catalog">
        <div className="container">
          <div className="work-grid">
            {projects.map((project) => (
              <Link
                key={project.slug}
                to="/work/$projectId"
                params={{ projectId: project.slug }}
                className="work-card"
              >
                <div
                  className={`work-card__visual project-visual--${project.accent}`}
                >
                  <ProjectMedia project={project} />
                  <b>
                    {l("查看案例", "View case")} <Arrow direction="up-right" />
                  </b>
                </div>
                <div className="work-card__body">
                  <span className="micro-label">{project.industry}</span>
                  <h2>{project.title}</h2>
                  <p>{project.summary}</p>
                  <TagList tags={project.tags} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
